import { Injectable } from '@angular/core';
import { EstabelecimentoModel } from '../../models/cadastro/estabelecimento.model';
import { RascunhoModel } from '../../models/cadastro/rascunho/rascunho.model';
import {CaracterizacaoModulo} from '../../models/cadastro/caracterizacao/caracterizacao.modulo';

@Injectable({
    providedIn: 'root'
})
export class GerenciadorCadastroEstabelecimentoService {
    rascunho: RascunhoModel = null;
    estabelecimento: EstabelecimentoModel = null;
    caracterizacaoGeral: CaracterizacaoModulo = new CaracterizacaoModulo();

    constructor() {
    }

    setEstabelecimento(dados?: any, codigoRascunho = 0, resultadoEndereco?: any, flag = 'identificacao'): EstabelecimentoModel {
        this.limparGerenciamento();
        this.estabelecimento = new EstabelecimentoModel(dados, codigoRascunho, resultadoEndereco, flag);
        return this.estabelecimento;
    }

    async estabelecimentoParaRascunho(): Promise<RascunhoModel> {
        return new RascunhoModel(this.estabelecimento);
    }

    async montarRascunho(): Promise<RascunhoModel> {
        return new RascunhoModel(this.estabelecimento);
    }

    async setCodigoRascunho(codigoRascunho) {
        this.estabelecimento.codigoRascunho = codigoRascunho;
    }

    setCaracterizacaoGeral(dadosCaracterizacao: any) {
        return this.caracterizacaoGeral.rascunhoParaCaracterizacaoGeral(dadosCaracterizacao);
    }
    pegarEstabelecimento() {
        return this.estabelecimento;
    }

    limparGerenciamento() {
        this.rascunho = null;
        this.estabelecimento = null;
    }
}
